import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { StrechChat }       from "Utils/API";

// Types
import {
    STRECH_CHAT, STRECH_CHAT_LOADING,
    STRECH_CHAT_LIST, STRECH_CHAT_ELEM,
    STRECH_CHAT_EDIT, STRECH_CHAT_CREATE,
} from "Utils/Types";



/**
 * Fetches the Chat List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch: Function) => Void}
 */
export function fetchChats(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : STRECH_CHAT_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "STRECH":
            params.strechID = elemID;
            data = await StrechChat.getAllForStrech(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : STRECH_CHAT_LIST, data });
        dispatch(setSection(STRECH_CHAT));
    };
}

/**
 * Fetches a single Chat
 * @param {Number} strechChatID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchChat(strechChatID) {
    return async (dispatch) => {
        const data = await StrechChat.getOne({ strechChatID });
        dispatch({ type : STRECH_CHAT_ELEM, data });
    };
}

/**
 * Fetches the Chat Edit data
 * @param {Number} strechChatID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchChatEdit(strechChatID) {
    return async (dispatch) => {
        const data = await StrechChat.getEditData({ strechChatID });
        dispatch({ type : STRECH_CHAT_EDIT, data });
    };
}

/**
 * Fetches the Chat Create data
 * @param {Number} strechID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchChatCreate(strechID) {
    return async (dispatch) => {
        const data = await StrechChat.getCreateData({ strechID });
        dispatch({ type : STRECH_CHAT_CREATE, data });
    };
}



/**
 * Edits/Creates a Chat
 * @param {Object} data
 * @returns {() => Void}
 */
export function editChat(data) {
    return () => StrechChat.edit(data);
}

/**
 * Deletes a Chat
 * @param {Number} strechChatID
 * @returns {() => Void}
 */
export function deleteChat(strechChatID) {
    return () => StrechChat.delete({ strechChatID });
}

/**
 * Imports Chats
 * @param {Number} strechID
 * @returns {() => Void}
 */
export function importChats(strechID) {
    return () => StrechChat.import({ strechID });
}
